import React from 'react';

const AllSeller = () => {
    return (
        <div>
            <h2 className='text-4xl'>All Seller</h2>
        </div>
    );
};

export default AllSeller;